import React, { useEffect, useState, useContext } from 'react'
import { Table, Button, Form } from 'react-bootstrap'
import { listUser, deleteUser } from '../Network/User'
import { listCompany } from '../Network/Company'
import { Loading, TablePagination, Container, HeaderTitle, AlertBar, UserProfileImage } from '../Library'
import { useHistory } from 'react-router-dom'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'
import "./User.css"
import { RoleContext } from '../Role/RoleContext'
import { AlertModalContext } from '../Library/AlertModalContext'

function User() {
    const alertModal = useContext(AlertModalContext)
    const role = useContext(RoleContext)
    const prefixAuthority = "NEWS_"
    const globalAuthority = "SET_GLOBAL"
    const companyAuthority = "SET_COMPANY"
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.user
    const history = useHistory();
    const [isFirst, setFirst] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [listUsers, setListusers] = useState([]);
    const [isSearching, setSearching] = useState(false)
    const [searchKeyword, setSearchKeyword] = useState("")
    const [searchUserList, setSearchUserList] = useState([])
    const [company, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState("")
    const [selectedDepartment, setSelectedDepartment] = useState("")

    // Content list
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const totalPage = Math.ceil(listUsers.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage

    const fetchData = (departmentId, selectedCompany) =>{
        listUser(departmentId, selectedCompany,
            (data)=>{
                setListusers(data);
                if(isFirst){
                    setAllUsers(data)
                    setFirst(false)
                }
                setLoading(false);
            },
            (error)=>{
                if(error.response !== undefined){
                    if(error.response.status === 401){
                        notifyCx.showNotify("Something wrong", "This user has expired please login again", 1)
                    }else{
                        notifyCx.showNotify("Something wrong", error.message, 2)
                    }
                }else{
                    notifyCx.showNotify("Something wrong", error.message, 2)
                }
                setLoading(false);
            }
        )
    }

    const fetchCompany = () =>{
        listCompany(
            (data)=>{ setCompany(data) },
            (error)=>{
                if(error.response !== undefined){
                    if(error.response.status === 401){
                        notifyCx.showNotify("Something wrong", "This user has expired please login again", 1)
                    }else{
                        notifyCx.showNotify("Something wrong", error.message, 2)
                    }
                }else{
                    notifyCx.showNotify("Something wrong", error.message, 2)
                }
                setLoading(false);
            }
        )
    }

    const onSearchUser = (e) =>{
        let val = e.target.value.toLowerCase()
        setSearchKeyword(e.target.value)
        
        if(val.length > 0){
            setSearching(true)
            var result = listUsers.filter((el)=>el.firstName.toLowerCase().includes(val) || el.email.toLowerCase().includes(val))
            setSearchUserList(result)
        }else{
            setSearching(false)
            setSearchUserList([])
        }
    }

    const isMaximumUser = () =>{
        let limitUser = localStorage.getItem("limit_user")
        let limitUserInt = parseInt(limitUser)
        if(allUsers.length >= limitUserInt && limitUserInt !== 0){
            return true
        }else{
            return false
        }
    }

    useEffect(()=>{
        setDocumentTitle("User")
        setLoading(true);
        fetchCompany()
        isMaximumUser()
        

        if(!role.checkPermission(prefixAuthority, companyAuthority)){
            let companyId = parseInt(localStorage.getItem("company_id"))
            setSelectedCompany(companyId)
            fetchData("", companyId);
        }else{
            fetchData(selectedDepartment, selectedCompany);
        }
    },[])

    const deleteUserFromList = (id, name) =>{
        alertModal.setTitle(lang.delete_user)
        alertModal.setDescription(lang.sure_to_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    deleteUser(id,
                        ()=>{
                            notifyCx.showNotify(lang.deleted_user, lang.delete_user_desc, 0)
                            fetchData("", selectedCompany);
                        },
                        (error)=>{
                            window.alert(error.message);
                            setLoading(false);
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
    }

    return (
        <Container topbarTitle={langCx.lang.sidebar.user}>
        { isLoading ? <Loading/>: null }
        <div id="user">
            <HeaderTitle
            title={lang.list_user}
            customRight={
                <Form.Control
                placeholder={lang.search_user}
                onChange={onSearchUser}
                value={searchKeyword}
                type="search"
                />
            }
            />
            { isMaximumUser() ?
            <AlertBar title={lang.meet_limit_user} priority={1} style={{ marginBottom: 10 }}/>
            : null
            }
            <div className="button-container">
                <div>
                { role.checkPermission("_MENU_", "app.user_add") ?
                <Button 
                className="manage-btn" 
                disabled={isMaximumUser()}
                onClick={()=>history.push("/user/create")}>
                    {lang.create_user}
                </Button>:null
                }
                { role.checkPermission("_MENU_", "app.user_import") ?
                <Button 
                className="manage-btn" 
                variant="secondary"
                onClick={()=>history.push("/user/import-export")}>
                    {lang.import_export}
                </Button>
                : null
                }
                </div>
                <div className="num-user">
                    <div style={{marginRight: 20}}>
                        <Form.Control as="select"
                        value={selectedCompany}
                        disabled={!role.checkPermission(prefixAuthority, companyAuthority) ? true:false}
                        style={{width: 160}}
                        onChange={(e)=>{
                            let companyId = e.target.value
                            setSelectedCompany(companyId)
                            fetchData("", companyId)
                        }}>
                            <option value="">{lang.all_user}</option>
                            { company.map((item, key)=>
                            <option value={item.id} key={key}>{item.name}</option>
                            )}
                        </Form.Control>
                    </div>
                    <div>
                    {listUsers.length} {lang.total_user}
                    </div>
                </div>
            </div>
            { isSearching ?
            <div className="search-bar-indicator">
                <b>{searchUserList.length}</b>{" " + lang.found_user}
                <a href="#"
                style={{marginLeft: 5}}
                onClick={(e)=>{
                    e.preventDefault()
                    setSearchKeyword("")
                    setSearching(false)
                }}
                >
                    {lang.clear_search}
                </a>
            </div>
            : null
            }
            <div className="table-container">
                <Table hover className="table-user">
                    <thead className="table-head">
                        <tr>
                            <th></th>
                            <th>{lang.employee_id}</th>
                            <th>{lang.firstname}</th>
                            <th>{lang.lastname}</th>
                            <th>{lang.position}</th>
                            <th>{lang.email}</th>
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { !isSearching ?
                        <>
                        {listUsers.slice(indexOfFirst, indexOfLast).map((item, key)=>
                            <UserItem
                            key={key}
                            onEditClick={()=>history.push("/user/edit/"+item.id)}
                            profileImagePath={item.profileImagePath}
                            employeeId={item.employeeId}
                            firstName={item.firstName}
                            lastName={item.lastName}
                            position={item.position}
                            email={item.email}
                            onDeleteClick={()=>deleteUserFromList(item.id, item.firstName + " " + item.lastName)}
                            />
                        )}
                        {listUsers.length === 0 ?
                        <tr style={{textAlign: 'center'}}>
                            <td colSpan={7}>{lang.no_user}</td>
                        </tr>
                        : null}
                        </>
                        :
                        <>
                        {searchUserList.map((item, key)=>
                            <UserItem
                            key={key}
                            onEditClick={()=>history.push("/user/edit/"+item.id)}
                            profileImagePath={item.profileImagePath}
                            employeeId={item.employeeId}
                            firstName={item.firstName}
                            lastName={item.lastName}
                            position={item.position}
                            email={item.email}
                            onDeleteClick={()=>deleteUserFromList(item.id, item.firstName + " " + item.lastName)}
                            />
                        )}
                        {searchUserList.length === 0 ?
                            <tr style={{textAlign: 'center'}}>
                                <td colSpan={7}>{lang.search_not_found}</td>
                            </tr>
                            : null
                        }
                        </>
                        }
                    </tbody>
                </Table>
                
            </div>
            { !isSearching ?
            <div className="pagination">
                <TablePagination
                dataLength={totalPage}
                size={10}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}
                />
            </div>
            : null
            }
        </div>
        </Container>
    )
}

function UserItem({ profileImagePath, employeeId, firstName, lastName, position, email, unavailable, onDeleteClick, onEditClick }){
    return(
        <tr
        style={{color: !unavailable ? "black":"lightgray"}}>
            <td style={{textAlign: 'center'}}>
                <UserProfileImage
                profileImagePath={profileImagePath}
                />
            </td>
            <td>{employeeId}</td>
            <td>{firstName}</td>
            <td>{lastName}</td>
            <td>{position}</td>
            <td>{email}</td>
            <td>
                { !unavailable ?
                <div className="action-container">
                <Button size="sm"
                onClick={onEditClick}>
                    <FontAwesomeIcon icon={faPen}/>
                </Button>
                <Button size="sm" variant="danger" style={{marginLeft: 10}}
                onClick={onDeleteClick}>
                    <FontAwesomeIcon icon={faTrash}/>
                </Button> 
                </div>
                : null
                }
            </td>
        </tr>
    )
}


export default User
